"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _descriptor2, _temp;

var LinkCard = (_class = (_temp =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(LinkCard, _Card$makeDefaultCard);

  function LinkCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, LinkCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(LinkCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "description", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "catalog", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(LinkCard, [{
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.catalog) return _react.default.createElement("p", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, this.description);
      if (this.description) return _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.description
        }
      });
      return null;
    }
  }, {
    key: "renderTileBody",
    value: function renderTileBody() {
      return _react.default.createElement("h3", null, this.objectTitle);
    }
  }], [{
    key: "tilePageId",
    value: function tilePageId() {
      return 'CatalogGroup';
    }
  }, {
    key: "tileForceUnlinked",
    value: function tileForceUnlinked() {
      return false;
    }
  }]);
  return LinkCard;
}(_base.default.makeDefaultCardType('link', 'Link')), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "catalog", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = LinkCard;